// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%276%27 viewBox=%270 0 8 6%27%3E%3Cpath id=%27Path_1%27 data-name=%27Path 1%27 d=%27M371,294l4,6,4-6Z%27 transform=%27translate%28-371 -294%29%27 fill=%27%23003d71%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .App {
  text-align: center;
  background-color: #29223D;
} */

/* Button */
.oc-btn.btn {
  font-size: 1.25rem;
  line-height: 1.5rem;
  padding: 0.9375rem 2.5rem;
  border-radius: 0.625rem;
}

.oc-btn.btn-primary {
  background-color: var(--oc-primary-color);
  border-color: var(--oc-primary-color);
}

/* Input field fonts */
label.MuiInputLabel-root {
  font-family: "DMSans-Bold" !important;
}

input.MuiInputBase-input {
  font-family: "DMSansMedium";
}

/* Dropdown */
.did-floating-label-content {
  position: relative;
  margin-bottom: 20px;
}

.did-floating-label {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  position: absolute;
  pointer-events: none;
  left: 15px;
  top: 11px;
  padding: 0 5px;
  background: #fff;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.did-floating-input,
.did-floating-select {
  font-size: 18px;
  display: block;
  width: 100%;

  height: 56px;
  padding: 0 20px;
  background: #fff;
  color: #000;
  border: 1px solid #000;
  border-radius: 4px;
  box-sizing: border-box;

  &:focus {
    outline: none;

    ~ .did-floating-label {
      top: -8px;
      font-size: 20px;
    }
  }
}

select.did-floating-select {
  appearance: none;
}

select.did-floating-select::-ms-expand {
  display: none;
}

.did-floating-input:not(:placeholder-shown) ~ .did-floating-label {
  top: -8px;
  font-size: 16px;
}

.did-floating-select:not([value=""]):valid ~ .did-floating-label {
  top: -8px;
  font-size: 16px;
}

.did-floating-select[value=""]:focus ~ .did-floating-label {
  top: -8px;
  font-size: 16px;
}

.did-floating-select:not([multiple]):not([size]) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 15px top 50%;
  background-repeat: no-repeat;
}

.activate-table {
  max-height: 300px;
  scrollbar-width:thin;
  scrollbar-color: #ff7b6d #d9d9d9;
}

.activate-table::-webkit-scrollbar {
  width: 0px;
  height: 6px;
}

.activate-table::-webkit-scrollbar-thumb {
  background-color: #ff7b6d;
}

.activate-table::-webkit-scrollbar-track {
  background-color: #646464;
}

.activate-table::-webkit-scrollbar::before {
  background-color: #d9d9d9;
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 8px;
}

.activate-table::-webkit-scrollbar::after {
  background-color: #d9d9d9;
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 8px;
}

@media screen and (min-width: 768px) {
  .activate-table::-webkit-scrollbar {
    width: 8px;
    height: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;GAGG;;AAEH,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,WAAW;;EAEX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;;EAEtB;IACE,aAAa;;IAEb;MACE,SAAS;MACT,eAAe;IACjB;EACF;AACF;;AAEA;EAGE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yDAA8P;EAC9P,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,WAAW;EACb;AACF","sourcesContent":["/* .App {\n  text-align: center;\n  background-color: #29223D;\n} */\n\n/* Button */\n.oc-btn.btn {\n  font-size: 1.25rem;\n  line-height: 1.5rem;\n  padding: 0.9375rem 2.5rem;\n  border-radius: 0.625rem;\n}\n\n.oc-btn.btn-primary {\n  background-color: var(--oc-primary-color);\n  border-color: var(--oc-primary-color);\n}\n\n/* Input field fonts */\nlabel.MuiInputLabel-root {\n  font-family: \"DMSans-Bold\" !important;\n}\n\ninput.MuiInputBase-input {\n  font-family: \"DMSansMedium\";\n}\n\n/* Dropdown */\n.did-floating-label-content {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.did-floating-label {\n  color: #000;\n  font-size: 18px;\n  font-weight: bold;\n  position: absolute;\n  pointer-events: none;\n  left: 15px;\n  top: 11px;\n  padding: 0 5px;\n  background: #fff;\n  transition: 0.2s ease all;\n  -moz-transition: 0.2s ease all;\n  -webkit-transition: 0.2s ease all;\n}\n\n.did-floating-input,\n.did-floating-select {\n  font-size: 18px;\n  display: block;\n  width: 100%;\n\n  height: 56px;\n  padding: 0 20px;\n  background: #fff;\n  color: #000;\n  border: 1px solid #000;\n  border-radius: 4px;\n  box-sizing: border-box;\n\n  &:focus {\n    outline: none;\n\n    ~ .did-floating-label {\n      top: -8px;\n      font-size: 20px;\n    }\n  }\n}\n\nselect.did-floating-select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\nselect.did-floating-select::-ms-expand {\n  display: none;\n}\n\n.did-floating-input:not(:placeholder-shown) ~ .did-floating-label {\n  top: -8px;\n  font-size: 16px;\n}\n\n.did-floating-select:not([value=\"\"]):valid ~ .did-floating-label {\n  top: -8px;\n  font-size: 16px;\n}\n\n.did-floating-select[value=\"\"]:focus ~ .did-floating-label {\n  top: -8px;\n  font-size: 16px;\n}\n\n.did-floating-select:not([multiple]):not([size]) {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6'%3E%3Cpath id='Path_1' data-name='Path 1' d='M371,294l4,6,4-6Z' transform='translate(-371 -294)' fill='%23003d71'/%3E%3C/svg%3E%0A\");\n  background-position: right 15px top 50%;\n  background-repeat: no-repeat;\n}\n\n.activate-table {\n  max-height: 300px;\n  scrollbar-width:thin;\n  scrollbar-color: #ff7b6d #d9d9d9;\n}\n\n.activate-table::-webkit-scrollbar {\n  width: 0px;\n  height: 6px;\n}\n\n.activate-table::-webkit-scrollbar-thumb {\n  background-color: #ff7b6d;\n}\n\n.activate-table::-webkit-scrollbar-track {\n  background-color: #646464;\n}\n\n.activate-table::-webkit-scrollbar::before {\n  background-color: #d9d9d9;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 8px;\n}\n\n.activate-table::-webkit-scrollbar::after {\n  background-color: #d9d9d9;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: 8px;\n}\n\n@media screen and (min-width: 768px) {\n  .activate-table::-webkit-scrollbar {\n    width: 8px;\n    height: 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
